module.exports = __webpack_public_path__ + "static/media/icon4.41d66a51.svg";